import React, { Component } from "react";
import { v4 as uuidv4 } from "uuid";

export class FiltroData extends Component {
  render() {
    const anos = [];

    this.props.noticias.map((noticia) => {
      let data = new Date(noticia.data);
      if (anos.indexOf(data.getFullYear()) === -1) {
        anos.push(data.getFullYear());
      }
      return anos;
    });

    return (
      <div className="filtro">
        <div className="meses">
          <ul value="0" className="mesesList" onClick={this.props.handleChange}>
            <li id="0" value="" className="selected">
              All
            </li>
            <li id="1" value="1">
              Jan
            </li>
            <li id="2" value="2">
              Fev
            </li>
            <li id="3" value="3">
              Mar
            </li>
            <li id="4" value="4">
              Abr
            </li>
            <li id="5" value="5">
              Mai
            </li>
            <li id="6" value="6">
              Jun
            </li>
            <li id="7" value="7">
              Jul
            </li>
            <li id="8" value="8">
              Ago
            </li>
            <li id="9" value="9">
              Set
            </li>
            <li id="10" value="10">
              Out
            </li>
            <li id="11" value="11">
              Nov
            </li>
            <li id="12" value="12">
              Dez
            </li>
          </ul>
        </div>
        <div className="mesesSel">
          <select
            name="Mes"
            value={this.props.filtroMes}
            onChange={this.props.handleChange}
          >
            <option value="">Mês...</option>
            <option value="1">Janeiro</option>
            <option value="2">Fevereiro</option>
            <option value="3">Março</option>
            <option value="4">Abril</option>
            <option value="5">Maio</option>
            <option value="6">Junho</option>
            <option value="7">Julho</option>
            <option value="8">Agosto</option>
            <option value="9">Setembro</option>
            <option value="10">Outubro</option>
            <option value="11">Novembro</option>
            <option value="12">Dezembro</option>
          </select>
        </div>
        <div className="select">
          <select
            name="Ano"
            value={this.props.filtroAno}
            onChange={this.props.handleChange}
          >
            <option value="">Ano...</option>
            {anos.map((ano) => (
              <option key={uuidv4()} value={ano}>
                {ano}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
}

export default FiltroData;
